import { useContext, useLayoutEffect } from 'react';

import { Theme, ThemeContext, ThemeContextType } from '../providers/theme-provider';

export const useUntitledUITheme = (overrideTheme?: Theme): ThemeContextType => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useUntitledUITheme must be used within a UntitledUIThemeProvider');
  }

  useLayoutEffect(() => {
    if (overrideTheme) {
      context.setTheme({ theme: overrideTheme, temporary: true });
      return () => {
        context.setTheme({ theme: undefined, temporary: true });
      };
    }
  }, [overrideTheme, context]);

  return context;
};
